import axios from 'axios'
import {
    Notification,
    MessageBox,
    Message,
    Loading
} from 'element-ui'

import store from '@/store'
import {
    getToken,removeToken
} from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import { tansParams, blobValidate } from "@/utils/ruoyi";
import { saveAs } from 'file-saver'
// import baseApi from '@/utils/baseApi'

console.log(errorCode.url)
let downloadLoadingInstance = '';

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
    //axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: errorCode.url,
    // 超时
    timeout: 20000
})


let loadingInstance = '';
// request拦截器
service.interceptors.request.use(config => {
    // console.log(config)
    if(!config.silent && config.url!='/loginQrCode'){
        loadingInstance = Loading.service({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(255, 255, 255, 0.7)",
        })
    }
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    if (getToken() && !isToken && config.url!='/loginQrCode'&& config.url!='/getQrCode'&& config.url!='/captchaImage'&& config.url!='/login' && config.url!='/loginOa') {
        config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // console.log('config.params:' + JSON.stringify(config.data))
    // get请求映射params参数
    if (config.method === 'get' && config.data) {
        let url = config.url + '?' + tansParams(config.data);
        url = url.slice(0, -1);
        config.data = {};
        config.url = url;
    }
    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

let isLogoutConfirm = false // confirm弹窗锁 防止重复弹出
// 响应拦截器
service.interceptors.response.use(res => {
    if (!res.config.silent && loadingInstance) {
        setTimeout(function () {
            loadingInstance.close();
        }, 500);
    }
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const message = errorCode[code] || res.data.msg || errorCode['default']
    if (code === 401) {
        if (isLogoutConfirm) return res

        removeToken()
        isLogoutConfirm = true
        MessageBox.confirm(
            '登录状态已过期，您可以继续留在该页面，或者重新登录',
            '系统提示', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
        }
        ).then(() => {
            isLogoutConfirm = false
            MessageBox.close()
            window.location.href="/login"
        }).catch(() => {
            isLogoutConfirm = false
            MessageBox.close()

        })
    } else if (code === 500) {
        if(!res.config.silent && res.config.url!='/loginQrCode'){
            Message({
                message: message,
                type: 'error'
            })
        }
        return Promise.reject(new Error(message))
    } else if (code !== 200) {
        if (!res.config.silent) Notification.error({ title: message })
        return Promise.reject('error')
    } else {
        return res.data || {}
    }
},
    error => {
        console.log('err' + error)
        if (!error.config || !error.config.silent) {
            if (loadingInstance) loadingInstance.close();
            Message({
                message: error.message,
                type: 'error',
                duration: 5 * 1000
            })
        }
        return Promise.reject(error)
    }
)


// 通用下载方法
export function download(url, params, filename) {
    downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
    return service.post(url, params, {
        transformRequest: [(params) => { return tansParams(params) }],
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        // headers: { 'Content-Type': 'application/json;charset=utf-8' },
        // headers: { isToken: false },
        responseType: 'blob'
    }).then(async (data) => {
        const isLogin = await blobValidate(data);
        if (isLogin) {
            const blob = new Blob([data])
            saveAs(blob, filename)
        } else {
            const resText = await data.text();
            const rspObj = JSON.parse(resText);
            const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
            Message.error(errMsg);
        }
        downloadLoadingInstance.close();
    }).catch((r) => {
        console.error(r)
        Message.error('下载文件出现错误，请联系管理员！')
        downloadLoadingInstance.close();
    })
}

export function downloadByGet(data) {
    const {url, params, filename, isToken = true} = data
    downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
    return service({
        method: 'get',
        url,
        data: params,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', isToken },
        responseType: 'blob'
    }).then(async (data) => {
        const isLogin = await blobValidate(data);
        if (isLogin) {
            const blob = new Blob([data])
            saveAs(blob, filename)
        } else {
            const resText = await data.text();
            const rspObj = JSON.parse(resText);
            const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
            Message.error(errMsg);
        }
        downloadLoadingInstance.close();
    }).catch((r) => {
        console.error(r)
        Message.error('下载文件出现错误，请联系管理员！')
        downloadLoadingInstance.close();
    })
}


export default service



// WEBPACK FOOTER //
// ./src/utils/request.js